export function removeAxeptioCookies(): void {
  if (typeof document === 'undefined') {
    return
  }

  const cookies = document.cookie.split(';')
  const expiredDate = 'Thu, 01 Jan 1970 00:00:00 UTC'
  const domain = '.swile.com.br'

  cookies.forEach((cookie) => {
    const [name] = cookie.trim().split('=')
    if (/axeptio/.exec(name.toLowerCase())) {
      document.cookie = `${name}=; expires=${expiredDate}; path=/; domain=${domain};`
    }
  })
}
